import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import is from 'is_js';

import { RepositoryService } from './../../shared/services/repository.service';
import { ErrorHandlerService } from './../../shared/services/error-handler.service';
import { CONST } from './../../shared/const';
import { Common } from './../../shared/common';

import { Init } from './../../_interfaces/init.model';
import { Receive } from './../../_interfaces/receive.model';
import { ApiStock } from './../../_interfaces/api-stock.model';
import { User } from './../../_interfaces/user.model';
import { Company } from './../../_interfaces/company.model';
import { Jan } from './../../_interfaces/jan.model';
import { Value } from './../../_interfaces/value.model';

@Component({
  selector: 'app-stock-detail',
  templateUrl: './stock-detail.component.html',
  styleUrls: ['./stock-detail.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(-100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})

export class StockDetailComponent implements OnInit {

  // Input Data //////////////////////////////////////
  public receive: Receive = new Receive();

  public editInventoryKubunId: number = -1;
  public editLocation: string = '';
  public editStockRemarks: string = '';

  // Master Data //////////////////////////////////////
  public categories: Value[] = [];
  public inchs: Value[] = [];
  public kubun1s: Value[] = [];
  public kubun2s: Value[] = [];
  public inventoryKubuns: Value[] = [];
  public riKubuns: Value[] = [];
  public bases: Value[] = [];
  public feceses: Value[] = [];
  public companies: Company[] = [];
  public jans: Jan[] = [];
  public users: User[] = [];

  // Etc Data ////////////////////////////////////////
  public isMobile: boolean = is.mobile();
  public isPad: boolean = is.ipad() || is.tablet();
  public isHorizontal: boolean = false;
  public version: string = CONST.VERSION;
  public menuState: string = CONST.MENU.OUT;
  public errorMessage: string = '';
  public isEdit: boolean = false;

  constructor(
    private repository: RepositoryService,
    private errorHandler: ErrorHandlerService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (Common.userId != '' || CONST.DEBUG) {
      this.getInit();
      this.isHorizontal = (window.orientation == 90);
      if (Common.id != '') {
        this.getDetailStock();
      }
    } else {
      this.router.navigate([CONST.VIEW.LOGIN]);
    }
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this.isHorizontal = (window.orientation == 90);
    setTimeout(() => {
      this.setImages();
    }, 500);
  }

  // View Action ////////////////////////////////////////////////////////////////
  public openMenu() {
    this.menuState = this.menuState === CONST.MENU.OUT ? CONST.MENU.IN : CONST.MENU.OUT;
  }

  public closeMenu() {
    this.menuState = CONST.MENU.OUT;
  }

  public logout() {
    this.router.navigate([CONST.VIEW.LOGIN]);
  }

  public back() {
    Common.id = '';
    this.router.navigate([CONST.VIEW.STOCK_LIST]);
  }

  public downloadImages() {
    this.errorMessage = '';
    this.getZipFile();
  }

  public edit() {
    this.editInventoryKubunId = this.receive.inventoryKubunId;
    this.editLocation = this.receive.location;
    this.editStockRemarks = this.receive.stock.remarks;
    this.isEdit = true;
  }

  public update() {
    this.errorMessage = '';
    this.stockUpdate();
  }

  // Private Function ///////////////////////////////////////////////////////////
  private setImages() {
    if (this.receive.arrive.imagePath1 != null && this.receive.arrive.imagePath1 != '') {
      let aImg1 = <HTMLImageElement> document.getElementById('aImg1');
      aImg1.src = this.receive.arrive.imagePath1;
    }
    if (this.receive.arrive.imagePath2 != null && this.receive.arrive.imagePath2 != '') {
      let aImg2 = <HTMLImageElement> document.getElementById('aImg2');
      aImg2.src = this.receive.arrive.imagePath2;
    }
    if (this.receive.arrive.imagePath3 != null && this.receive.arrive.imagePath3 != '') {
      let aImg3 = <HTMLImageElement> document.getElementById('aImg3');
      aImg3.src = this.receive.arrive.imagePath3;
    }
    if (this.receive.arrive.imagePath4 != null && this.receive.arrive.imagePath4 != '') {
      let aImg4 = <HTMLImageElement> document.getElementById('aImg4');
      aImg4.src = this.receive.arrive.imagePath4;
    }

    if (this.receive.process.imagePath1 != null && this.receive.process.imagePath1 != '') {
      let pImg1 = <HTMLImageElement> document.getElementById('pImg1');
      pImg1.src = this.receive.process.imagePath1;
    }
    if (this.receive.process.imagePath2 != null && this.receive.process.imagePath2 != '') {
      let pImg2 = <HTMLImageElement> document.getElementById('pImg2');
      pImg2.src = this.receive.process.imagePath2;
    }
    if (this.receive.process.imagePath3 != null && this.receive.process.imagePath3 != '') {
      let pImg3 = <HTMLImageElement> document.getElementById('pImg3');
      pImg3.src = this.receive.process.imagePath3;
    }
    if (this.receive.process.imagePath4 != null && this.receive.process.imagePath4 != '') {
      let pImg4 = <HTMLImageElement> document.getElementById('pImg4');
      pImg4.src = this.receive.process.imagePath4;
    }
    if (this.receive.process.imagePath5 != null && this.receive.process.imagePath5 != '') {
      let pImg5 = <HTMLImageElement> document.getElementById('pImg5');
      pImg5.src = this.receive.process.imagePath5;
    }
    if (this.receive.process.imagePath6 != null && this.receive.process.imagePath6 != '') {
      let pImg6 = <HTMLImageElement> document.getElementById('pImg6');
      pImg6.src = this.receive.process.imagePath6;
    }
  }

  // Web Api ////////////////////////////////////////////////////////////////////
  private getInit() {
    let apiAddress: string = CONST.API.INIT.GET_DATA;
    let res = this.repository.getData(apiAddress).subscribe(res => {
      let init = res as Init;
      this.categories = init.categories;
      this.inchs = init.inchs;
      this.kubun1s = init.kubun1s;
      this.kubun2s = init.kubun2s;
      this.inventoryKubuns = init.inventoryKubuns;
      this.riKubuns = init.riKubuns;
      this.bases = init.bases;
      this.feceses = init.feceses;
      this.companies = init.companies;
      this.jans = init.jans;
      this.users = init.users;
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }

  public getDetailStock() {
    let apiAddress: string = CONST.API.STOCK.DETAIL;
    let params = {
      id: Common.id
    }
    let res = this.repository.post(apiAddress, params).subscribe(res => {
      let receive = res as Receive;
      this.receive = receive;
      this.setImages();
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }

  private stockUpdate() {
    let apiAddress: string = CONST.API.STOCK.UPDATE;
    let params = new ApiStock();
    params.id = this.receive.id;
    params.inventoryKubunId = this.editInventoryKubunId;
    params.stockRemarks = this.editStockRemarks;
    params.location = this.editLocation;
    params.createdUserId = Common.userId;
    params.updatedUserId = Common.userId;
    let res = this.repository.post(apiAddress, params).subscribe(res => {
      this.isEdit = false;
      this.editInventoryKubunId = -1;
      this.editLocation = '';
      this.editStockRemarks = '';
      $('#successModal').modal();
      this.getDetailStock();
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }

  private getZipFile() {
    let apiAddress: string = CONST.API.STOCK.CSV_DOWNLOAD;
    let params = {id: this.receive.id};
    this.repository.postFile(apiAddress, params).subscribe(res => {
      let blob = new Blob([(<any>res)], {type: 'application/zip'});
      let dt = new Date();
      let y = dt.getFullYear();
      let m = ("00" + (dt.getMonth()+1)).slice(-2);
      let d = ("00" + dt.getDate()).slice(-2);
      let h = ("00" + dt.getHours()).slice(-2);
      let mi = ("00" + dt.getMinutes()).slice(-2);
      let s = ("00" + dt.getSeconds()).slice(-2);
      let now = y + m + d + h + mi + s;

      let csvFileName = `画像_${this.receive.id}_${now}.zip`;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, csvFileName);
      } else {
        let link = document.createElement('a');
        link.setAttribute('href', window.URL.createObjectURL(blob));
        link.setAttribute('download', csvFileName);
        document.body.appendChild(link);
        link.click()
        link.remove();
      }
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }
}
